export enum NavDirection {
  forward = 1,
  back = -1,
}
